<template>
  <b-modal
    centered
    v-model="isShow"
    title="Add Attachment"
    size="lg"
    hide-footer
  >
    <div class="">
      <b-row class=" mt-3">
        <b-col  class="justify-content-center">
          <UploadFileV2
            textFloat="File"
            placeholder="Please Choose File"
            format=""
            name="file"
            text="*Please upload file less than 20 MB"
            isRequired
            v-on:onFileChange="uploadFile"
            v-on:delete="deleteFile"
            :fileName="filename"
            v-model="attachment"
            id="uploadfile"
            :v="$v.filename"
            :isValidate="$v.filename.$error"
            :limitFileSize="20"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button size="md" @click="hide" variant="outline-primary-color" class="btn-width">Cancel</b-button>
        </b-col>
        <b-col class="text-right">
          <b-button
            id="upload"
            class="btn-primary-color btn-width"
            size="md"
            @click="submit"
            >Upload</b-button
          >
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import UploadFileV2 from "./UploadFileV2";
import { required } from "vuelidate/lib/validators";
export default {
  components:{
    UploadFileV2
  },
  validations() {
    return {
      filename: {
        required,
      },
    };
  },
  data() {
    return { isShow: false, filename: "", attachment: "" };
  },
  methods: {
    hide() {
      this.isShow = false;
    },
    show() {
      this.$v.filename.$reset();
      this.isShow = true;
      this.filename = null;
      this.attachment = null;
    },
    async submit() {
   
        this.$v.filename.$touch();
        if (this.$v.filename.$error) return;
        await this.$store.dispatch("setMainLoading", true);
        let payload = {
          Base64String: this.attachment,
          is_video: false,
          is_file: true,
          type: 1,
          file_name: this.filename,
        };
        const result = await this.axios.post(`${this.$baseUrl}/customer/UploadFile`, payload);
        await this.$store.dispatch("setMainLoading", false);
        let data = result.detail

        this.$emit("uploadFile", {
          mim_type: this.filename,
          data: data
        });
      

    },
    uploadFile(file) {
      this.filename = file.name;
      this.isDisable = false;

      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.attachment = reader.result;
        this.submit();
      };
    },
    deleteFile() {
      this.attachment = null;
      this.filename = null;
      this.isDisable = true;
    },
  },
};
</script>

<style>
/* .btn-outline-primary-color {
  border-color: var(--primary-color) !important; 
  color: var(--primary-color)!important; 
  background-color:  var(--secondary-color)!important;
  margin-top: 0!important; 
} */
</style>
